import type { MenuSection } from '@1js/acui-menu/lib/components/MenuDefinition';
import { MailRibbonTabId, MailRibbonControlId } from 'owa-ribbon-ids';
import { createMailGeneratedMenuFlyoutAnchor } from '../../util/createMailRibbonButton';
import type { MenuItemControlProps } from '@1js/acui-ribbon-like/lib/UISurfaces/controls/Menu';
import { getControlInfo } from 'owa-mail-ribbon-utils';
import getConversationsSections from './getConversationsSections';
import getMessagePreviewSections from './getMessagePreviewSections';
import { constructKeytip, getKeytipString } from 'owa-command-ribbon';

export default function getMessagesSections(tabId: MailRibbonTabId): MenuSection[] {
    let sections: MenuItemControlProps[] = [];

    // add conversations menu
    const conversationsControlInfo = getControlInfo(MailRibbonControlId.Conversations);
    sections.push(
        createMailGeneratedMenuFlyoutAnchor(
            MailRibbonControlId.Conversations,
            conversationsControlInfo.text,
            conversationsControlInfo.tooltip,
            {
                sections: getConversationsSections(),
            },
            constructKeytip(
                [getKeytipString(tabId), getKeytipString(MailRibbonControlId.Messages)],
                getKeytipString(MailRibbonControlId.Conversations)
            ),
            false,
            conversationsControlInfo.iconName
        )
    );

    // add message preview menu
    const previewControlInfo = getControlInfo(MailRibbonControlId.MessagePreview);
    sections.push(
        createMailGeneratedMenuFlyoutAnchor(
            MailRibbonControlId.MessagePreview,
            previewControlInfo.text,
            previewControlInfo.tooltip,
            {
                sections: getMessagePreviewSections(),
            },
            constructKeytip(
                [getKeytipString(tabId), getKeytipString(MailRibbonControlId.Messages)],
                getKeytipString(MailRibbonControlId.MessagePreview)
            ),
            false,
            previewControlInfo.iconName
        )
    );

    return [
        {
            controls: sections,
        },
    ];
}
